import React, { Component } from 'react';

import './App.css';
import logo from './Ganjedibles-logo.png';
import leaf from './abstract-ganja-leaf.png';

class Projects extends Component {

  render() {
    return (
        <div className="projects-main">
          <div className="page-heading"> Projects </div>
          <div className="ganjedibles">
            <img src={logo} className="ganjedibles-logo" alt="Ganjedibles logo"/>
            <p> Ganjedibles&trade; are the result of an initiative by Progressive Jamaica to create a marijuana edible with
                all Jamaican ingredients while keeping flavour a top priority. When produced at high volume, this product
                 provides a stimulus to the chocolate, coconut, ganja, and sugar industries.
            </p>
            <img src={leaf} className="ganja-leaf-img" alt="Abstract Ganja Leaf" />
          </div>
        </div>
    );
  }
}

export default Projects;



/** WEBPACK FOOTER **
 ** ./src/Projects.js
 **/